import React, { useState } from "react";

type IStudentContext = {
  name: string;
  setState?: Function;
};

export const StudentsContext = React.createContext<Partial<IStudentContext>>(
  {}
);

type Props = { children: React.ReactNode };

export default function StudentsProvider({ children }: Props) {
  const [state, setState] = useState<Partial<IStudentContext>>();

  return (
    <StudentsContext.Provider value={{ ...state, setState }}>
      {children}
    </StudentsContext.Provider>
  );
}
